import api from './base';

export const groupsApi = {
  getAll: (token) =>
    api.get('/users/groups', {
      headers: { Authorization: `Token ${token}` },
    }),

  getById: (groupId, token) =>
    api.get(`/users/groups/${groupId}`, {
      headers: { Authorization: `Token ${token}` },
    }),

  create: (groupData, token) =>
    api.post('/users/groups', groupData, {
      headers: { Authorization: `Token ${token}` },
    }),

  update: (groupId, groupData, token) =>
    api.put(`/users/groups/${groupId}`, groupData, {
      headers: { Authorization: `Token ${token}` },
    }),

  delete: (groupId, token) =>
    api.delete(`/users/groups/${groupId}`, {
      headers: { Authorization: `Token ${token}` },
    }),

  getMembers: (groupId, token) =>
    api.get(`/users/groups/${groupId}/members`, {
      headers: { Authorization: `Token ${token}` },
    }),

  addMember: (groupId, userId, token) =>
    api.post(
      `/users/groups/${groupId}/members`,
      { user_id: userId },
      { headers: { Authorization: `Token ${token}` } }
    ),

  removeMember: (groupId, userId, token) =>
    api.delete(`/users/groups/${groupId}/members/${userId}`, {
      headers: { Authorization: `Token ${token}` },
    }),

  getSharedResources: (groupId, token) =>
    api.get(`/users/groups/${groupId}/shared-resources`, {
      headers: { Authorization: `Token ${token}` },
    }),
};
